import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.blur');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import {
    cellyticsAnalysisDataUrl,
    cellyticsAnalysisSet,
    cellyticsCurrentAnalysisSetId,
    cellyticsDefaultAnalysisSet,
} from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";
const ACCESS_SESSION_VALUE = "granted";
const ACCESS_USER = {
    id: "cellytics-access",
    email: "",
    name: "Cellytics NK",
    role: "admin",
};
const BOX_BLUR_METHOD_ID = "box_2x2";
const BOX_BLUR_METHOD_LABEL = "2x2 Box blur";

@Component({
    selector: 'wiz-page-blur',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.blur/view.scss */
/* src/app/page.blur/view.scss: no such file or directory */`],
})
export class PageBlurComponent implements OnInit, OnDestroy {
    public analysis: any = null;
    public analysisSetId: string = "";
    public analysisSet: any = null;
    public loading: boolean = true;
    public error: string = "";
    public selectedSampleId: string = "";
    public selectedBlurMethodId: string = BOX_BLUR_METHOD_ID;
    public imageModal: any = null;

    public metricRows: any[] = [
        { key: "CMV", label: "CMV" },
        { key: "PPD", label: "PPD" },
        { key: "MMD", label: "MMD" },
        { key: "MMD_SD", label: "MMD_STD" },
        { key: "WCM", label: "WCM" },
        { key: "WCM_SD", label: "WCM_STD" },
        { key: "WSM", label: "WSM" },
        { key: "WSM_SD", label: "WSM_STD" },
        { key: "CSP", label: "CSP" },
    ];

    private routerSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.hasAccess()) {
            location.href = "/access";
            return;
        }
        this.applyAccessSession();
        this.syncAnalysisSet();
        this.bindRouteChanges();
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private hasAccess() {
        return this.service.auth.check() || window.sessionStorage.getItem(ACCESS_SESSION_KEY) === ACCESS_SESSION_VALUE;
    }

    private applyAccessSession() {
        if (this.service.auth.check()) return;
        this.service.auth.status = true;
        this.service.auth.session = ACCESS_USER;
    }

    private syncAnalysisSet() {
        this.analysisSetId = cellyticsCurrentAnalysisSetId();
        this.analysisSet = cellyticsAnalysisSet(this.analysisSetId) || cellyticsDefaultAnalysisSet();
    }

    private bindRouteChanges() {
        if (this.routerSub) return;
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (!(event instanceof NavigationEnd)) return;
            const nextSetId = cellyticsCurrentAnalysisSetId();
            if (nextSetId === this.analysisSetId) return;
            this.syncAnalysisSet();
            await this.load();
        });
    }

    public async load() {
        this.syncAnalysisSet();
        this.loading = true;
        this.error = "";
        await this.service.render();

        try {
            const response = await fetch(cellyticsAnalysisDataUrl(this.analysisSetId), { cache: "no-cache" });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.analysis = await response.json();
            this.selectedSampleId = this.samples[0]?.id || "";
            this.selectedBlurMethodId = this.blurMethodSummary[0]?.methodId || BOX_BLUR_METHOD_ID;
        } catch (error) {
            this.error = "분석 데이터를 불러오지 못했습니다.";
        }

        this.loading = false;
        await this.service.render();
    }

    public get samples() {
        return this.analysis?.samples || [];
    }

    public get selectedSample() {
        return this.samples.find((sample: any) => sample.id === this.selectedSampleId) || this.samples[0] || null;
    }

    private sampleById(sampleId: string) {
        return this.samples.find((sample: any) => sample.id === sampleId) || null;
    }

    private isTrustedNative(sample: any = this.selectedSample) {
        return sample?.nativeVerified === true;
    }

    public get blurMethodAnalysis() {
        const analysis = this.analysis?.blurMethodAnalysis || null;
        if (!analysis) return null;

        const summary = (analysis.summary || [])
            .filter((row: any) => row.methodId === BOX_BLUR_METHOD_ID)
            .map((row: any, index: number) => ({ ...row, rank: index + 1 }));
        const methods = (analysis.methods || [])
            .filter((row: any) => (row.id || row.methodId) === BOX_BLUR_METHOD_ID);
        const samples = (analysis.samples || []).map((sample: any) => ({
            ...sample,
            methods: (sample.methods || []).filter((row: any) => row.methodId === BOX_BLUR_METHOD_ID),
        })).filter((sample: any) => sample.methods.length);
        const best = summary[0] || null;

        return {
            ...analysis,
            methods,
            summary,
            samples,
            bestMethodId: best?.methodId || BOX_BLUR_METHOD_ID,
            bestMethodLabel: best?.label || BOX_BLUR_METHOD_LABEL,
        };
    }

    public get blurMethodSummary() {
        return this.blurMethodAnalysis?.summary || [];
    }

    public get selectedSampleBlurAnalysis() {
        if (!this.selectedSample || !this.blurMethodAnalysis) return null;
        return this.blurMethodAnalysis.samples?.find((sample: any) => sample.sampleId === this.selectedSample.id) || null;
    }

    public get selectedBlurMethod() {
        return this.blurMethodSummary.find((row: any) => row.methodId === this.selectedBlurMethodId) || this.blurMethodSummary[0] || null;
    }

    public get selectedSampleBlurMethod() {
        if (!this.selectedSampleBlurAnalysis) return null;
        return this.selectedSampleBlurAnalysis.methods?.find((row: any) => row.methodId === this.selectedBlurMethodId) || this.selectedSampleBlurAnalysis.methods?.[0] || null;
    }

    public get currentBlurVisual() {
        return this.selectedSample?.visuals?.blurVisual || null;
    }

    public async selectSample(sampleId: string) {
        this.selectedSampleId = sampleId;
        await this.service.render();
    }

    public async selectBlurMethod(methodId: string) {
        this.selectedBlurMethodId = methodId;
        await this.service.render();
    }

    public sampleActiveClass(sampleId: string) {
        if (this.selectedSampleId === sampleId) {
            return "flex items-center justify-between gap-3 rounded-lg border border-blue-500 bg-blue-50 px-3 py-2 text-left text-[13px] font-semibold text-blue-800";
        }
        return "flex items-center justify-between gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[13px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public methodActiveClass(methodId: string) {
        if (this.selectedBlurMethodId === methodId) {
            return "rounded-lg border border-blue-500 bg-blue-50 px-3 py-2 text-left text-[12px] font-semibold text-blue-800";
        }
        return "rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-[12px] font-medium text-gray-600 hover:border-gray-300 hover:bg-gray-50";
    }

    public methodCardClass(methodId: string) {
        if (this.selectedBlurMethodId === methodId) return "overflow-hidden rounded-lg border border-blue-500 bg-blue-50 text-left ring-1 ring-blue-500";
        return "overflow-hidden rounded-lg border border-gray-200 bg-white text-left hover:border-gray-300 hover:bg-gray-50";
    }

    public deltaClass(value: any) {
        if (value > 0) return "text-blue-700";
        if (value < 0) return "text-red-600";
        return "text-gray-500";
    }

    public signed(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        const numberValue = Number(value);
        const prefix = numberValue > 0 ? "+" : "";
        return `${prefix}${this.format(numberValue, digits)}`;
    }

    public format(value: any, digits: number = 0) {
        if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
        return Number(value).toLocaleString("ko-KR", {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    public metricDelta(row: any, key: string) {
        return row?.metricDeltas?.[key] || {};
    }

    public summaryMetric(row: any, key: string) {
        return row?.metricSummary?.[key] || {};
    }

    public visualImage(visual: any, key: string) {
        const fullKey = `${key}Full`;
        const downloadKey = `${key}Download`;
        return this.imageRef(
            visual?.[key],
            visual?.[fullKey],
            visual?.[downloadKey],
            visual?.[fullKey] && visual?.[fullKey] !== visual?.[key] ? visual?.nativeWidth : null,
            visual?.[fullKey] && visual?.[fullKey] !== visual?.[key] ? visual?.nativeHeight : null,
            this.isTrustedNative(),
        );
    }

    public blurSourceImage(sample: any) {
        return this.imageRef(
            sample?.source,
            sample?.sourceFull,
            sample?.sourceDownload,
            sample?.sourceFull && sample?.sourceFull !== sample?.source ? sample?.nativeWidth : null,
            sample?.sourceFull && sample?.sourceFull !== sample?.source ? sample?.nativeHeight : null,
            this.isTrustedNative(this.sampleById(sample?.sampleId)),
        );
    }

    public blurMethodImage(row: any, key: string = "preview") {
        if (key === "residualHeatmap") {
            return this.imageRef(
                row?.residualHeatmap,
                row?.residualHeatmapFull,
                row?.residualDownloadImage,
                row?.residualHeatmapFull && row?.residualHeatmapFull !== row?.residualHeatmap ? row?.nativeWidth : null,
                row?.residualHeatmapFull && row?.residualHeatmapFull !== row?.residualHeatmap ? row?.nativeHeight : null,
                this.isTrustedNative(),
            );
        }
        return this.imageRef(
            row?.preview,
            row?.fullImage,
            row?.downloadImage,
            row?.fullImage && row?.fullImage !== row?.preview ? row?.nativeWidth : null,
            row?.fullImage && row?.fullImage !== row?.preview ? row?.nativeHeight : null,
            this.isTrustedNative(),
        );
    }

    private imageRef(preview: string, fullImage: string = "", downloadImage: string = "", nativeWidth: any = null, nativeHeight: any = null, trustedNative: boolean = false) {
        const resolvedPreview = preview || fullImage || downloadImage || "";
        const useNative = trustedNative && !!fullImage && !!nativeWidth && !!nativeHeight;
        const resolvedFull = useNative ? fullImage : resolvedPreview;
        const resolvedDownload = useNative ? (downloadImage || resolvedFull) : "";
        return {
            preview: resolvedPreview,
            fullImage: resolvedFull,
            downloadImage: resolvedDownload,
            nativeWidth: useNative ? nativeWidth : null,
            nativeHeight: useNative ? nativeHeight : null,
            nativeTrusted: useNative,
        };
    }

    private resolveImageInput(input: any) {
        if (typeof input === "string") return this.imageRef(input);
        return this.imageRef(
            input?.preview || input?.src || input?.source || "",
            input?.fullImage || input?.full || input?.sourceFull || "",
            input?.downloadImage || input?.download || input?.sourceDownload || "",
            input?.nativeWidth || null,
            input?.nativeHeight || null,
            input?.nativeTrusted === true,
        );
    }

    private modalFileName(title: string, src: string) {
        const ext = (src || "").split("?")[0].split(".").pop() || "jpg";
        const safeTitle = (title || "cellytics-image")
            .replace(/[^0-9A-Za-z._-]+/g, "_")
            .replace(/^_+|_+$/g, "") || "cellytics-image";
        return safeTitle.endsWith(`.${ext}`) ? safeTitle : `${safeTitle}.${ext}`;
    }

    public async openImageModal(input: any, title: string, caption: string = "") {
        const image = this.resolveImageInput(input);
        const src = image.fullImage || image.preview;
        this.imageModal = {
            src,
            preview: image.preview,
            download: image.downloadImage || "",
            filename: this.modalFileName(title, src),
            nativeWidth: image.nativeWidth,
            nativeHeight: image.nativeHeight,
            usingNative: !!image.nativeWidth && !!image.nativeHeight,
            title,
            caption,
        };
        await this.service.render();
    }

    public async closeImageModal() {
        this.imageModal = null;
        await this.service.render();
    }
}

export default PageBlurComponent;